import React from 'react';
import {
  Card,
  Row,
  Col,
  InputNumber,
  Typography
} from 'antd';

const { Text } = Typography;

const GSTSection = ({
  gst,
  onGSTChange,
  subtotalAfterDiscount = 0
}) => {
  const calculateGSTAmount = () => {
    if (gst.percentage <= 0) return 0;
    return subtotalAfterDiscount * (gst.percentage / 100);
  };

  return (
    <Card title="GST (Optional)" style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={8}>
          <div style={{ marginBottom: 8 }}>
            <Text>GST Percentage</Text>
          </div>
          <InputNumber
            min={0}
            max={100}
            precision={2}
            value={gst.percentage}
            onChange={(value) => onGSTChange({ percentage: value || 0 })}
            style={{ width: '100%' }}
            formatter={(value) => `${value}%`}
            parser={(value) => value.replace('%', '')}
            placeholder="0.00"
          />
        </Col>
        <Col span={8}>
          {gst.percentage > 0 && (
            <>
              <div style={{ marginBottom: 8 }}>
                <Text>GST Amount</Text>
              </div>
              <Text strong style={{ color: '#1890ff' }}>
                +${calculateGSTAmount().toFixed(2)}
              </Text>
            </>
          )}
        </Col>
        <Col span={8}>
          {gst.percentage > 0 && (
            <>
              <div style={{ marginBottom: 8 }}>
                <Text>Applied On</Text>
              </div>
              <Text type="secondary">
                Subtotal after discount
              </Text>
            </>
          )}
        </Col>
      </Row>
    </Card>
  );
};

export default GSTSection;
